import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const Evolucionamos = () => {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-white py-24 md:py-36"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 md:gap-16 items-start">
          <div className="lg:col-span-5">
            <p className="text-[11px] tracking-[0.35em] uppercase text-[#6F2DBD] font-semibold mb-6 flex items-center gap-3">
              <span className="inline-block w-10 h-px bg-[#6F2DBD]" />
              {t.evol.overline}
            </p>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8 }}
              data-testid="about-title"
              className="font-display text-[#002B6B] text-4xl md:text-5xl lg:text-6xl leading-[1.02] uppercase"
            >
              {t.evol.title}
            </motion.h2>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-7 lg:pl-12 lg:border-l lg:border-[#E4E7ED]"
          >
            <p className="text-lg md:text-xl text-[#1A1F2C] leading-[1.5] font-editorial font-light mb-6">
              {t.evol.p1}
            </p>
            <p className="text-base text-[#6B7280] leading-relaxed font-light">
              {t.evol.p2}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Evolucionamos;
